var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _g, _g2, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintanancePatterSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 460,
    viewBox: "0 0 80 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 60,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 100,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 140,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 180,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 220,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 260,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 300,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 340,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 380,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 420,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 100,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 160,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 220,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 280,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 140,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 200,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 260,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 180,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 240,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 120,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 180,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 240,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 160,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 220,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 280,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 80,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 140,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 200,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 260,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 120,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 180,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 240,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 20,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1932_6023)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 20,
    height: 20,
    fill: "#251D97"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1932_6023)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 20,
    height: 20,
    fill: "#251D97"
  }))), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 140,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 200,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 260,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 40,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 100,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 160,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 220,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 280,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 340,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 400,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 320,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 380,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 440,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 300,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 360,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 420,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 300,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 360,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 420,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 340,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 400,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 320,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 380,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 440,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 300,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 360,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 420,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 320,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 380,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 440,
    width: 20,
    height: 20,
    fill: "#251D97"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 340,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 400,
    width: 20,
    height: 20,
    fill: "#FF249E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1932_6023",
    x: 16,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_6023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_6023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1932_6023",
    x: 56,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_6023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_6023",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintanancePatterSmall);
export default __webpack_public_path__ + "static/media/maintanance-patter-small.f2b1ac4f0cfbe97f90bee871aae02a33.svg";
export { ForwardRef as ReactComponent };